import H3 from "@material-tailwind/react/Heading3";
import Image from "@material-tailwind/react/Image";
import Paragraph from '@material-tailwind/react/Paragraph';
import React from 'react';
import Fade from 'react-reveal/Fade';
import me from '../images/me.jpg';

const About = () => {
    return (
        <div id='about' className="w-full min-h-screen flex items-center justify-center p-4">
            <Fade left><div className="lg:w-2/4 lg:block hidden">
                <Image
                    className='w-4/5 mx-auto'
                    src={me}
                    rounded={true}
                    raised={true}
                    alt="Rounded Image"
                />
            </div></Fade>
            <Fade right> <div className="lg:w-2/4 w-full">
                <H3 color="lightBlue">About Me</H3>

                <Paragraph color="gray">
                    I have been coding for more than four years now since my first line of code. During this time, I had the opportunity to explore different programming languages like Java, JavaScript, Python and, Dart. I have explored several technologies like Flutter, Native android app development using Java. I have built full-stack web apps using React and Node.js. I have written a couple of software development relevant blogs in Medium.
                </Paragraph>
                <Paragraph color="gray">
                    I have hands-on experience in frontend technologies like React, React Router, React Hooks, Context API, JavaScript(ES6), Tailwind CSS, Reactstrap, Bootstrap, HTML, CSS. Backend technologies like Node.js, Express, MongoDB, Firebase authentication JWT based authentication. I have experience with version control systems like git. I am familiar with testing frameworks like Jest. I am well versed in Object-Oriented Programming, Design Patterns, and Solid Principles.

                </Paragraph>
            </div></Fade>
        </div>
    );
};

export default About;